// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tournaments-main[data-v-421bbb47] {\n  margin: 0;\n}\n\n.card[data-v-421bbb47] {\n  background-color: var(--magic-tertiary, #311261);\n}\n\n.link[data-v-421bbb47] {\n  --magic-text-primary: var(--magic-light, #fff);\n}", ""]);
// Exports
module.exports = exports;
